export default "__VITE_ASSET__Hs96fH6U__"